import styled from 'src/styles'

export const Wrapper = styled.div``
